export enum FieldNames {
    USERNAME = 'username',
    PASSWORD = 'password',
    CME = 'cme',
    SERVER = 'server',
    LOCALE = 'locale',
    REMEMBER_ME = 'rememberMe'
}

export const USERNAME_FIELD_NAME: string = FieldNames.USERNAME
export const PASSWORD_FIELD_NAME: string = FieldNames.PASSWORD
export const CME_FIELD_NAME: string = FieldNames.CME
export const SERVER_FIELD_NAME: string = FieldNames.SERVER
export const LOCALE_FIELD_NAME: string = FieldNames.LOCALE
export const REMEMBER_ME_FIELD_NAME: string = FieldNames.REMEMBER_ME
